
import * as React from 'react';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { type Row } from '@process-advisor/process-miner/api/methods/slicers/setVariantSlicerSelectedGridData';
import { DataGrid } from '@process-advisor/process-miner/slicers/variants/dataGrid';
import { variantGridColumnsVisualizer } from '@process-advisor/process-miner/slicers/variants/variantGridColumnsVisualizer';
import { variantGridColumnsTime } from '@process-advisor/process-miner/slicers/variants/variantGridColumnsTime';

import { Event } from '@process-advisor/process-miner/api/events';

export const VariantsGrid = (mode) => {
    const [data, setData] = React.useState<Row[]>([]);
    const [rows, setRows] = React.useState();
    const [columns, setColumns] = React.useState<any>();
    const [height, setHeight] = React.useState<any>();

    React.useEffect(() => {
        setData(apiProvider.variantsTable({}));
  
        if (mode.mode === 'process_miner') {
            setColumns(variantGridColumnsVisualizer)
            setHeight('320px')
        }
        else {
            setColumns(variantGridColumnsTime)
            setHeight('600px')
        }
        setData(apiProvider.variantsTable({}));
    }, [mode]);

    React.useEffect(() => {

        const listener = () => { 
            setData(apiProvider.variantsTable({}));
        };       
        apiProvider.on(Event.updateDurationColumns, listener);
        apiProvider.on(Event.resetTimeFilter, listener);
        apiProvider.on(Event.processDiscoveryRule, listener);
        apiProvider.on(Event.setTopXVariants, listener);
        return () => {
            apiProvider.off(Event.updateDurationColumns, listener);
            apiProvider.off(Event.resetTimeFilter, listener);
            apiProvider.off(Event.processDiscoveryRule, listener);
            apiProvider.off(Event.setTopXVariants, listener);
       };
        
    }, []);

    React.useEffect(() => {
        setRows(data.map((row, id) => ({ id, ...row })))
    }, [data]);

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            height={height}
            mode={mode} />
    );
};

